var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 16,
    viewBox: "0 0 40 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.04011 9.41793H2.21044V15.9964H0V0H7.80707C12.0941 0 13.2916 2.43486 13.2916 4.71077C13.2916 6.49176 12.322 8.54008 9.47847 9.12892L13.8559 16H11.262L7.04373 9.42154L7.04011 9.41793ZM2.21044 7.59359H7.49233C10.1333 7.59359 10.969 6.19553 10.969 4.68548C10.969 3.17543 10.1333 1.84601 7.51766 1.84601H2.21044V7.59359Z",
    fill: "#19181A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4733 0H17.2812V1.86769H36.4733V0Z",
    fill: "#19181A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4733 14.1318H17.2812V15.9995H36.4733V14.1318Z",
    fill: "#19181A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4733 7.06543H17.2812V8.93312H36.4733V7.06543Z",
    fill: "#19181A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.1cffdb638c36419b961f68f097a682f2.svg";
export { ForwardRef as ReactComponent };